<template>
    <form-wrapper @form-submit="submit">
        <form-row>
            <form-cell width="half">
                <text-input
                    class="availability-inputs__item"
                    :label="$t('forms.availability.add_availability.heading.label')"
                    :prefillVal="timelineTitle"
                    :placeholder="$t('forms.availability.add_availability.heading.placeholder')"
                    :showInfoTip="true"
                    :infoTipMessage="$t('forms.availability.add_availability.heading.tool_tip_message')"
                    :containerDimensions="modalDimensions"
                    @change="setTimelineTitle"
                ></text-input>
            </form-cell>
            <form-cell width="half">
                <text-input
                    class="availability-inputs__item"
                    type="number"
                    :label="$t('forms.availability.add_availability.max_days.label')"
                    :placeholder="$t('forms.availability.add_availability.max_days.placeholder')"
                    :prefillVal="bookingDaysLimit"
                    :showInfoTip="true"
                    :infoTipMessage="$t('forms.availability.add_availability.max_days.tool_tip_message')"
                    :containerDimensions="modalDimensions"
                    @change="bookingDaysChanged"
                ></text-input>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell width="half">
                <datepicker-input
                    ref="validFrom"
                    class="availability-inputs__item"
                    :label="$t('forms.availability.add_availability.from_date.label')"
                    :placeholder="$t('forms.availability.add_availability.from_date.placeholder')"
                    :upperLimit="upperLimit"
                    :lowerLimit="lowerLimit"
                    :showInfoTip="true"
                    :infoTipMessage="$t('forms.availability.add_availability.from_date.tool_tip_message')"
                    :containerDimensions="modalDimensions"
                    @date-changed="dateFromChanged"
                ></datepicker-input>
            </form-cell>
            <form-cell width="half">
                <datepicker-input
                    ref="validTo"
                    class="availability-inputs__item"
                    :label="$t('forms.availability.add_availability.to_date.label')"
                    :placeholder="$t('forms.reservations.reservation_filter.fields.date_to.placeholder')"
                    :lowerLimit="lowerLimit"
                    :showInfoTip="true"
                    :infoTipMessage="$t('forms.availability.add_availability.to_date.tool_tip_message')"
                    :containerDimensions="modalDimensions"
                    @date-changed="dateToChanged"
                ></datepicker-input>
            </form-cell>
        </form-row>
        <template #footer>
            <common-buttons>
                <common-button
                    type="secondary"
                    size="large-long"
                    :isSubmittable="false"
                    :isProcessing="isLoading"
                    :label="$t('common.microcopy.close')"
                    @click="emitEvent({ name: 'close' })"
                ></common-button>
                <common-button
                    type="tertiary"
                    size="large-long"
                    :isDisabled="!timelineTitle"
                    :isProcessing="isLoading"
                    :label="$t('common.microcopy.save')"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import FormInputMixin from 'mixins/FormInputMixin'
    import OfferTypeEnum from 'enums/offer_type.enum'
    import OfferAPI from 'api/OfferAPI'
    import dayjs from 'dayjs'
    import { dateFormat } from '~/helpers'

    export default {
        mixins: [FormMixin, FormInputMixin],

        props: {
            query: { type: Object, default: undefined },
            modalSize: { type: Object, default: undefined },
        },

        data() {
            return {
                upperLimit: null,
                lowerLimit: null,
                validFrom: null,
                validTo: null,
                isLoading: false,
                timelineTitle: undefined,
                bookingDaysLimit: 90,
                parentComponentSize: undefined,
                modalDimensions: undefined,
            }
        },

        methods: {
            dateFromChanged(value) {
                if (value !== undefined) {
                    this.lowerLimit = dateFormat(value)
                    this.validFrom = value
                } else {
                    this.lowerLimit = new Date()
                    this.validFrom = null
                }
            },
            dateToChanged(value) {
                if (value !== undefined) {
                    this.upperLimit = dateFormat(value)
                    this.validTo = value
                } else {
                    this.upperLimit = null
                    this.validTo = null
                }
            },

            submit() {
                this.isLoading = true
                const isUserOffer = this.$route.params.type === OfferTypeEnum.USER
                const req = isUserOffer ? OfferAPI.addUserAvailability : OfferAPI.addCompanyAvailability

                req({
                    offerId: this.query.offer.id,
                    timeline: this.query.timeline,
                    companyId: this.query.companyId,
                    timelineTitle: this.timelineTitle,
                    performerId: this.query.performerId,
                    moderatorIds: this.query.moderatorIds,
                    moderatorInvites: this.query.moderatorInvites,
                    validFrom: this.validFrom,
                    validTo: this.validTo,
                    bookingDaysLimit: Number(this.bookingDaysLimit) || null,
                })
                    .then(() => {
                        this.isLoading = false
                        this.emitEvent({ name: 'success' })
                    })
                    .catch(() => {
                        this.isLoading = false
                    })
            },

            setTimelineTitle({ value }) {
                if (value !== undefined) {
                    this.timelineTitle = value
                }
            },
            bookingDaysChanged({ value }) {
                if (value !== undefined) {
                    this.bookingDaysLimit = value
                }
            },
        },

        mounted() {
            const el = this.$el.getBoundingClientRect()
            this.modalDimensions = {
                width: el.width,
            }
            this.$refs.validFrom.selected = dateFormat(dayjs().format('YYYY-MM-DD'))
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/mixins';

    .availability-inputs {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        max-width: 800px;
        margin: 0 auto;

        &__item {
            @media only screen and (max-width: 600px) {
                width: 100%;
                padding-bottom: 10px;
            }
        }
    }
    .availability-button {
        display: flex;
        justify-content: center;
    }

    .modal__body {
        @include breakpoint(smartphone-large) {
            padding: 0 !important;
        }
    }
</style>
